import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { timeSinceText } from '../../../lib/time';
import Loader from '../../../components/Loader';
import ServiceRequestDialogue from './ServiceRequestDialogue';

const StyledTableContainer = withStyles({
  root: {
    borderRadius: '5px',
  },
})(TableContainer);

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontSize: '0.7rem',
    padding: '0.3rem 0.4rem',
  },
  body: {
    fontSize: '0.7rem',
    padding: '0.3rem 0.4rem',
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    '&:hover': {
      backgroundColor: theme.palette.common.highlightBlue,
    },
    cursor: 'pointer',
  },
}))(TableRow);

const useStyles = makeStyles({
  root: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'flex-start',
    justifyContent: 'flex-start',
    padding: '0',
  },
});

const ServiceRequestList = ({data=null}) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [item, setItem] = React.useState(null);

  const handleClickOpen = (idx) => {
    setItem(data[idx]);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setItem(null);
  };

  if (data === null) {
    return (<Loader />);
  }

  return (
    <div className={classes.root}>
      <ServiceRequestDialogue
        data={item}
        open={open}
        handleClose={handleClose}
      />
      <StyledTableContainer>
        <Table>
          <TableHead>
            <StyledTableRow>
              <StyledTableCell>Request ID</StyledTableCell>
              <StyledTableCell>Status</StyledTableCell>
              <StyledTableCell>Type</StyledTableCell>
              <StyledTableCell>Classification</StyledTableCell>
              <StyledTableCell>Requested Provider</StyledTableCell>
              <StyledTableCell>Requester Email</StyledTableCell>
              <StyledTableCell>Requester Location</StyledTableCell>
              <StyledTableCell>Updated</StyledTableCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {data.map((row, idx) => {
              const provider = 'provider_name' in row.relations ? row.relations.provider_name : 'NA';
              return (
                <StyledTableRow key={row.short_id} onClick={()=>handleClickOpen(idx)}>
                  <StyledTableCell>{row.short_id}</StyledTableCell>
                  <StyledTableCell>{row.status}</StyledTableCell>
                  <StyledTableCell>{row.group_type}</StyledTableCell>
                  <StyledTableCell>{'classification' in row.detail ? row.detail.classification : 'NA'}</StyledTableCell>
                  <StyledTableCell>{provider}</StyledTableCell>
                  <StyledTableCell>{row.detail.contact.email}</StyledTableCell>
                  <StyledTableCell>{row.detail.location}</StyledTableCell>
                  <StyledTableCell>{row.updated_at === null ? timeSinceText(row.created_at) : timeSinceText(row.updated_at)}</StyledTableCell>
                </StyledTableRow>
              );
            })}
          </TableBody>
        </Table>
      </StyledTableContainer>
    </div>
  );
};

ServiceRequestList.propTypes = {
  data: PropTypes.array,
};

export default ServiceRequestList;
